import axios, { AxiosInstance } from 'axios';
import type { LocaleResponse } from '../types/textCms';

const isProduction = process.env.NODE_ENV === 'production';
const isTest = process.env.REACT_APP_URL_BACKEND_API?.includes('test.medbioinformatics.com');

let API_URL: string;

if (isProduction && !isTest) {
  // Producción
  API_URL = process.env.REACT_APP_TEXT_CMS_API_URL_PROD || 'https://ej6r7qkjyd.execute-api.eu-central-1.amazonaws.com';
} else {
  // Test
  API_URL = process.env.REACT_APP_TEXT_CMS_API_URL_TEST || 'https://ab3lgjqe87.execute-api.eu-central-1.amazonaws.com';
}

class TextCmsService {
  private apiClient: AxiosInstance;

  constructor() {
    this.apiClient = axios.create({
      baseURL: API_URL,
      timeout: 10000,
      headers: {
        'Content-Type': 'application/json'
      }
    });
  }

  async getTexts(locale: string = 'en'): Promise<LocaleResponse> {
    const response = await this.apiClient.get<LocaleResponse>(`/texts/${locale}`);
    return response.data;
  }
}

export const textCmsService = new TextCmsService();

export default textCmsService;
